import {remCalc} from '_themeUtils'

const footerSocials = {
    FooterSocials: {
        baseStyle: () => ({
            section: {
                gap: {base: 'spacing.4', md: 'spacing.6'},
            },
            title: {
                textStyle: {base: 'paragraphXl', md: 'paragraphMd'},
                textTransform: {base: 'uppercase', md: 'none'},
                fontWeight: 500,
            },
            socialList: {
                gap: {base: 'spacing.2', md: 'spacing.4'},
                flexWrap: 'wrap',
                justify: {base: 'center', md: 'flex-start'},
                position: 'relative',
            },
            socialItem: {
                minW: 'unset',
                minH: 'unset',
            },
            weChatQrCode: {
                display: 'block',
                position: 'absolute',
                zIndex: 'tooltip',
                overflow: 'hidden',
                top: 'spacing.12',
                left: 0,
                p: 'spacing.2',
                minWidth: remCalc(136),
                maxWidth: remCalc(136),
                minHeight: remCalc(136),
                maxHeight: remCalc(136),
                boxShadow: `0 2px 7px 0 rgba(0, 0, 0, 0.05)`,
            },
        }),
    },
}

export default footerSocials
